import { conditionLabel } from "@/lib/store";

export const ConditionChip = ({ p, className = "", testid }) => (
  <span data-testid={testid} className={`inline-flex items-center rounded-full border border-white/15 px-3 py-1 text-sm text-zinc-200 ${className}`}>
    {conditionLabel(p)}
  </span>
);
